import SkeletonSync from '@components/Skeleton/SkeletonSync';
import { Button, Skeleton, Spin } from 'antd';
import React, { useEffect, useState } from 'react';
import { Spinner } from 'reactstrap';

import { Modal } from 'semantic-ui-react';

type Props = {
  isOpen: boolean;
  url: string | null;
  title?: string;
  notFoundMessage?: string;
  onOk: () => void;
  onCancel: () => void;
};

export default function EmbedModal({
  isOpen,
  onOk,
  onCancel,
  url,
  title,
  notFoundMessage = 'Nenhum item encontrado.',
}: Props) {

  const [isLoading, setIsLoadting] = useState(true);

  useEffect(() => {
    setIsLoadting(true);
  }, [isOpen]);

  return (
    <Modal
      open={isOpen}
      onClose={onOk}
      onCancel={onCancel}
      centered
      closeOnEscape
      closeOnDocumentClick>
      <Modal.Header>{title || 'Vídeos'}</Modal.Header>
      {!url && (
        <Modal.Content>
          <p>{notFoundMessage}</p>
        </Modal.Content>
      )}
      {url && (
        <>
          <iframe
            width="100%"
            height="500px"
            src={url}
            onLoad={() => setIsLoadting(false)}
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            title="Imóvel"
          />
          {isLoading && <div style={{ width: "100%", display: 'flex', flexDirection: 'column', alignItems: 'center', position: 'absolute', height: '500px', top: '250px' }}>
              <strong>Aguarde...</strong>
              <br />
              <Spinner />
          </div>}
        </>
      )}
      <Modal.Actions>
        <Button color="black" onClick={onOk}>
          Fechar
        </Button>
      </Modal.Actions>
    </Modal>
  );
}
